import * as React from 'react';

var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagramIcon_svg__a",
    cx: 51.992,
    cy: 13.509,
    r: 684.445,
    gradientTransform: "matrix(.0566 -1.08 .918 .04811 -5.988 520.557)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fed576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    style: {
      stopColor: "#f47133"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    style: {
      stopColor: "#bc3081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4c63d2"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagramIcon_svg__a)",
    d: "M0 249.5v13.8C3.6 395.7 110.2 502 237.1 512h39C403.7 501.9 508.5 394.7 512 263.1v-13.6C508.5 115.6 400.1 7 269.4.3 128.8-6.8 3.9 106 0 249.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.2 128.6c40.8 0 45.6.1 61.8.9 14.9.6 22.9 3.2 28.3 5.3 7.1 2.8 12.2 6.2 17.5 11.6s8.7 10.6 11.5 17.8c2.1 5.5 4.5 13.7 5.3 28.9.8 16.4.9 21.3.9 62.8s-.1 46.4-.9 62.8c-.6 15.1-3.1 23.4-5.3 28.9-2.8 7.2-6.1 12.4-11.5 17.8-5.3 5.4-10.4 8.8-17.5 11.6-5.4 2.2-13.5 4.7-28.3 5.3-16.1.8-21 .9-61.8.9s-45.6-.1-61.8-.9c-14.9-.6-22.9-3.2-28.3-5.3-7.1-2.8-12.2-6.2-17.5-11.6s-8.7-10.6-11.5-17.8c-2.1-5.5-4.5-13.7-5.3-28.9-.8-16.4-.9-21.3-.9-62.8s.1-46.4.9-62.8c.6-15.1 3.1-23.4 5.3-28.9 2.8-7.2 6.1-12.4 11.5-17.8 5.3-5.4 10.4-8.8 17.5-11.6 5.4-2.2 13.5-4.7 28.3-5.3 16.1-.7 21-.9 61.8-.9m0-28c-41.5 0-46.7.2-62.9 1s-27.4 3.4-37.1 7.2c-10.1 4-18.6 9.3-27 18-8.5 8.7-13.7 17.3-17.6 27.6-3.8 9.8-6.4 21.2-7.1 37.7-.8 16.5-.9 21.8-.9 64s.2 47.5.9 64c.8 16.5 3.4 27.8 7.1 37.7 3.9 10.2 9.1 18.9 17.6 27.6s17 14 27 18c9.7 3.9 20.9 6.5 37.1 7.2 16.3.8 21.5 1 62.9 1s46.7-.2 62.9-1 27.4-3.4 37.1-7.2c10.1-4 18.6-9.3 27-18 8.5-8.7 13.7-17.3 17.6-27.6 3.8-9.8 6.4-21.2 7.1-37.7.8-16.5.9-21.8.9-64s-.2-47.5-.9-64c-.8-16.5-3.4-27.8-7.1-37.7-3.9-10.2-9.1-18.9-17.6-27.6s-17-14-27-18c-9.7-3.9-20.9-6.5-37.1-7.2-16.2-.8-21.5-1-62.9-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.2 176.2c-43.4 0-78.4 35.7-78.4 79.8s35.1 79.8 78.4 79.8 78.4-35.7 78.4-79.8-35.1-79.8-78.4-79.8m0 131.6c-28.1 0-50.9-23.1-50.9-51.8s22.8-51.8 50.9-51.8 50.9 23.1 50.9 51.8-22.8 51.8-50.9 51.8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.7,
    cy: 173,
    rx: 18.3,
    ry: 18.6
  }))));
};

export { SvgInstagramIcon as default };
